export const REQUEST_EVENTS_LIST_COLUMNS = [
  'direction',
  'dateSend',
  'dateReceived',
  'type', // responseCode || resultCode
  'state',
  'message'
];
